(function () {
	var form = document.querySelector('.submit-event-form');
	if (!form) {
		return;
	}

	var uploadInput = form.querySelector('.submit-event-upload__input');
	var uploadText = form.querySelector('.submit-event-upload__text');
	var uploadHint = form.querySelector('[data-submit-event-upload-hint]');
	var uploadList = form.querySelector('[data-submit-event-upload-list]');
	var defaultUpload = uploadText ? uploadText.textContent : '';
	var defaultHint = uploadHint ? uploadHint.textContent : '';

	function formatMb(bytes) {
		return (bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '') + ' MB';
	}

	function isJpg(name) {
		return /\.jpe?g$/i.test(name || '');
	}

	function renderList(files) {
		if (!uploadList) {
			return;
		}
		uploadList.innerHTML = '';
		if (!files.length) {
			uploadList.setAttribute('hidden', '');
			return;
		}
		uploadList.removeAttribute('hidden');
		Array.prototype.forEach.call(files, function (file) {
			var item = document.createElement('li');
			item.className = 'submit-event-upload__item';
			item.textContent = file.name + ' · ' + formatMb(file.size);
			if (!isJpg(file.name)) {
				item.classList.add('is-alt');
			}
			uploadList.appendChild(item);
		});
	}

	if (uploadInput && uploadText) {
		uploadInput.addEventListener('change', function () {
			var files = uploadInput.files ? Array.prototype.slice.call(uploadInput.files, 0) : [];
			var softMax = parseInt(uploadInput.getAttribute('data-soft-max') || '0', 10);
			var hardMax = parseInt(uploadInput.getAttribute('data-hard-max') || '0', 10);
			var maxCount = parseInt(uploadInput.getAttribute('data-max-count') || '6', 10);

			if (!files.length) {
				uploadText.textContent = defaultUpload;
				renderList([]);
				if (uploadHint) {
					uploadHint.textContent = defaultHint;
					uploadHint.classList.remove('is-warn', 'is-error');
				}
				return;
			}

			if (files.length === 1) {
				uploadText.textContent = files[0].name;
			} else {
				uploadText.textContent = files.length + ' photos selected';
			}
			renderList(files);

			if (!uploadHint) {
				return;
			}

			if (maxCount && files.length > maxCount) {
				uploadHint.textContent = 'You can upload up to ' + maxCount + ' photos.';
				uploadHint.classList.add('is-error');
				uploadHint.classList.remove('is-warn');
				return;
			}

			var tooBig = files.some(function (file) {
				return hardMax && file.size > hardMax;
			});
			if (tooBig) {
				uploadHint.textContent =
					'One or more files are over ' + formatMb(hardMax) + '. Prefer JPG under that size.';
				uploadHint.classList.add('is-error');
				uploadHint.classList.remove('is-warn');
				return;
			}

			var large = files.some(function (file) {
				return softMax && file.size > softMax;
			});
			var nonJpg = files.some(function (file) {
				return !isJpg(file.name);
			});

			if (large) {
				uploadHint.textContent =
					'Large file(s) selected. We will resize them and flag them for an editor glance.' +
					(nonJpg ? ' JPG is preferred when you can.' : '');
				uploadHint.classList.add('is-warn');
				uploadHint.classList.remove('is-error');
				return;
			}

			if (nonJpg) {
				uploadHint.textContent = 'JPG is preferred. PNG, GIF, or WebP also work.';
				uploadHint.classList.add('is-warn');
				uploadHint.classList.remove('is-error');
				return;
			}

			uploadHint.textContent = defaultHint;
			uploadHint.classList.remove('is-warn', 'is-error');
		});
	}
})();
